import { ComponentsModule } from './../components/components.module';
import { FormsModule } from '@angular/forms';
import { AuthService } from './auth/auth.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PipesModule } from './pipes/pipes.module';
import { MoviesService } from './services/movies.service';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [FooterComponent, HeaderComponent],
  exports: [FooterComponent, HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    FormsModule,
    PipesModule,
    ComponentsModule,
  ],
  providers: [MoviesService, AuthService],
})
export class CoreModule { }
